(ns minorodata.logs.model
  (:require [mold.core :as m :include-macros true]))


(declare ->logs-view ->log-pagination ->log-message ->logs-pager)

(m/defmodel logs-view
  {:type       [::m/string "Type filter"]
   :source     [::m/string "Source filter"]
   :term       [::m/string "Term filter"]
   :page       [::m/number "Current pager state"]
   :total      [::m/number "Total number of items"]
   :sort-by    [::m/keyword "Sort field"]
   :sort-order [::m/string "Sort order"]
   :date-from  [::m/string  "Filter from date"]
   :date-to    [::m/string  "Filter to date"]}
  {:singleton true})


(m/defmodel log-pagination
  {:items-per-page [::m/number "Items per page that server returns"]
   :page           [::m/number "Page number"]
   :has-more       [::m/bool "Has more pages?"]}
  {:singleton true})


(m/defmodel log-message
  {:id             [::m/req ::m/string ::m/not-empty ::m/identity "Unique log ID"]
   :created-at     [::m/string "Log record date"]
   :message-type   {::m/req  true
                    ::m/type ::m/enum
                    ::m/vals #{"INFO" "SUCCESS" "FAILURE"}
                    ::m/doc  "Log type enum"}
   :message-source [::m/string "Log source name"]
   :message        [::m/map "Log JSON representation"]})


(m/defmodel logs-pager
  {:messages ["Messages ids"]}
  {:singleton true})
